<template>

<div>

	<forms-tab
		:title="'Completed Company Forms for '+ $store.employee.first_name + ' ' + $store.employee.last_name"
		:employee-id="$store.employee.id">
	</forms-tab>

</div>

</template>
<script type="text/javascript">

import FormsTab from "@/components/super_components/FormsTab";

export default {
	name: "EmployeeForms",
	components: {
		FormsTab
	}
}
</script>